/**
 * @file Syncs the residual MUI components (@mui/x-data-grid, carousel, OTP
 * input) to the Mantine color scheme. Mounted once inside ThemeProvider.
 */
import { useMemo } from 'react';
import PropTypes from 'prop-types';
import { ThemeProvider as MuiThemeProvider, createTheme } from '@mui/material/styles';
import { useThemeMode } from './useThemeMode';
import { semanticPalette } from './semanticColors';
import { coral, teal } from './colors';

const MuiThemeBridge = ({ children }) => {
  const { mode } = useThemeMode();

  const muiTheme = useMemo(() => {
    const palette = semanticPalette[mode];
    return createTheme({
      palette: {
        mode,
        primary: { main: mode === 'dark' ? coral[5] : coral[6] },
        secondary: { main: mode === 'dark' ? teal[5] : teal[6] },
        background: { default: palette.surface.base, paper: palette.surface.raised },
        text: { primary: palette.text.primary, secondary: palette.text.secondary },
        error: { main: palette.status.error },
        divider: palette.border.default
      },
      typography: { fontFamily: 'inherit' }
    });
  }, [mode]);

  return <MuiThemeProvider theme={muiTheme}>{children}</MuiThemeProvider>;
};

MuiThemeBridge.propTypes = {
  children: PropTypes.node
};

export default MuiThemeBridge;
